export default "__VITE_ASSET__1246d11a__"